import React, {useRef, useState, useEffect, Fragment} from 'react';
import 'fontsource-roboto';
import {makeStyles} from '@material-ui/core/styles';
import useIsMountedRef from './../Components/useIsMountedRef';
import useForceUpdate from './../Components/useForceUpdate';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import ReactExport from 'react-data-export';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import DeleteIcon from '@material-ui/icons/Delete';

import EditableField from '../Components/EditableField';
import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(.5, 0)
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(1, 0)
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  listItemDense: {
    paddingTop: '0px',
    paddingBottom: '0px'
  },
  listItemTextDense: {
    marginTop: '0px',
    marginBottom: '0px'
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide {...props} direction='up' />;
});

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function ExternLabs(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();
  const forceUpdate = useForceUpdate();

  const [isLoaded, setIsLoaded] = useState(false);
  const [filter, setFilter] = useState({
    idCompany: '',
    method: ''
  });
  const [data, setData] = useState({});
  const [checked, setChecked] = useState([]);
  const [deleteIdService, setDeleteIdService] = useState(null);

  const prevData = usePrevious({data});

  useEffect(() => {
    setIsLoaded(false);
    ajax('externLabsUnsentServices')
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);

        setIsLoaded(true);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!prevData || JSON.stringify(prevData.data.companies) === JSON.stringify(data.companies))
      return;

    if (Boolean(data.companies) && Boolean(data.companies.length) && Boolean(data.methods) && Boolean(data.methods.length)) {
      setFilter({
        idCompany: data.companies[0].id,
        method: data.methods.filter(option => option.idCompany === data.companies[0].id)[0].method
      });
    }
  }, [data.companies, data.methods, prevData]);

  const handleFilterChange = e => {
    setFilter({
      idCompany: e.target.name === 'idCompany' ? e.target.value : filter.idCompany,
      method: e.target.name === 'idCompany' ? data.methods.filter(option => option.idCompany === e.target.value)[0].method : e.target.value
    });
  };

  useEffect(() => {
    if (data.services)
      setChecked(data.services.filter(filterData).filter(item => !Boolean(~['64', '70'].indexOf(item.idCompany)) || (Boolean(~['64', '70'].indexOf(item.idCompany)) && Boolean(item.phone) && Boolean(item.county) && Boolean(item.city) && Boolean(item.address))).map(item => item.id));
  }, [data.services, filter]); // eslint-disable-line react-hooks/exhaustive-deps

  const filterData = item => true
      && (filter.idCompany === '' || item.idCompany === filter.idCompany)
      && ((filter.method === 'Normal' && item.method === null) || item.method === filter.method);

  const handleToggle = service => () => {
    if (Boolean(~['64', '70'].indexOf(service.idCompany)) && (!Boolean(service.phone) || !Boolean(service.county) || !Boolean(service.city) || !Boolean(service.address)))
      return;

    const newChecked = [...checked];
    if (!~checked.indexOf(service.id))
      newChecked.push(service.id);
    else
      newChecked.splice(checked.indexOf(service.id), 1);
    setChecked(newChecked);
  };

  const handleDataUpdate = e => {
    let tmpData = data;
    tmpData.services.forEach((v, i, a) => {
      if (v.idPerson === e.idPerson) {
        switch (e.what) {
          case 'phone':
            a[i].phone = e.newValue;
            break;
          case 'county':
            a[i].county = e.newValue;
            break;
          case 'city':
            a[i].city = e.newValue;
            break;
          case 'address':
            a[i].address = e.newValue;
            break;

          default:
            break;
        }
      }
    });
    setData(tmpData);
    forceUpdate();
  };

  const externLabsMarkServiceAsDeleted = () => {
    setIsLoaded(false);
    ajax('externLabsMarkServiceAsDeleted', {
      idReceptionServiceSL: deleteIdService
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          setData(response.data);
          setDeleteIdService(null);
        }

        setIsLoaded(true);
      });
  };

  return (
    <Container maxWidth='md'>
      <Typography variant='h6'>Laboratoare externe</Typography>
      <Typography variant='subtitle2'>Generare borderouri de recoltare si cereri de analize pentru probele trimise catre laboratoarele externe</Typography>
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded && data.services.length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda conditiilor cerute.</Warning>
      }

      {isLoaded && data.services.length > 0 &&
        <Grid container spacing={1}>
          <Grid item xs={12} sm={5}>
            <TextField margin='none' required select
              label='Laborator extern'
              placeholder='Laborator extern'
              name='idCompany'
              value={filter.idCompany}
              onChange={handleFilterChange}
            >
              {data.companies.map(option => (
                <MenuItem key={option.id} value={option.id}>
                  {option.company}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField margin='none' required select
              disabled={filter.idCompany === ''}
              label='Metoda de transport'
              placeholder='Metoda de transport'
              name='method'
              value={filter.method}
              onChange={handleFilterChange}
            >
              {data.methods.filter(option => option.idCompany === filter.idCompany).map(option => (
                <MenuItem key={option.method} value={option.method}>
                  {option.method}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={2}>
            {filter.idCompany === '64' &&
              <ExcelFile
                filename={`Borderou_COVID-19_${(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60 * 1000))).toISOString()}`}
                element={
                  <Button fullWidth variant='contained' color='primary' size='large'
                    disabled={!Boolean(checked.length)}
                    onClick={() => {
                      window.open(`${props.url.download}?op=externLabsOrder&idCompany=${filter.idCompany}&method=${filter.method}&idReceptionServicesSL=${checked.join(',')}&SID=${props.user.sessid}&variant=live`);
                      setIsLoaded(false);
                      ajax('externLabsUnsentServices', {
                        idReceptionServicesSL: checked
                      })
                        .then(response => {
                          if (!isMountedRef.current) return;

                          if (response.ok)
                            setData(response.data);

                          setIsLoaded(true);
                        });
                    }}
                  >
                    Genereaza
                  </Button>
                }
              >
                <ExcelSheet
                  data={data.services.filter(service => !!~checked.indexOf(service.id)).map((service, i) => ({...service, nrCrt: i + 1}))}
                  name={`Borderou COVID-19 ${(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60 * 1000))).toISOString().split('T')[0]}`}
                >
                  <ExcelColumn label='Nr.' value='nrCrt' />
                  <ExcelColumn label='Nume' value='person' />
                  <ExcelColumn label='Prenume' value={() => ''} />
                  <ExcelColumn label='CNP' value='cnp' />
                  <ExcelColumn label='Sector / Localitate' value='city' />
                  <ExcelColumn label='Judet' value='county' />
                  <ExcelColumn label='Adresa' value='address' />
                  <ExcelColumn label='Telefon' value='phone' />
                  <ExcelColumn label='Email' value='email' />
                  <ExcelColumn label='Cod proba' value='idReceptionSL' />
                  <ExcelColumn label='Act identitate CI' value={() => ''} />
                  <ExcelColumn label='Act identitate pasaport' value={() => ''} />
                  <ExcelColumn label='Parafa' value={() => ''} />
                  <ExcelColumn label='Nume' value={() => ''} />
                  <ExcelColumn label='Prenume' value={() => ''} />
                  <ExcelColumn label='Tip solicitare proba COVID' value={() => 'La cerere'} />
                  <ExcelColumn label='Tip pacient COVID' value={() => 'Altele'} />
                  <ExcelColumn label='COVID' value={() => '1'} />
                  <ExcelColumn label='GRIPA' value={() => '0'} />
                  <ExcelColumn label='Data recoltarii' value='dateOfSample' />
                  {/* <ExcelColumn label='Tip proba' value={() => 'EXUDAT NAZO-FARINGIAN'} /> */}
                </ExcelSheet>
              </ExcelFile>
            }
            {filter.idCompany === '70' &&
              <ExcelFile
                filename={`Borderou_COVID-19_${(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60 * 1000))).toISOString()}`}
                element={
                  <Button fullWidth variant='contained' color='primary' size='large'
                    disabled={!Boolean(checked.length)}
                    onClick={() => {
                      ajax('downloadExternLabsOrder', {
                        idCompany: filter.idCompany,
                        idReceptionServicesSL: checked
                      })
                        .then(response => {
                          if (!isMountedRef.current) return;

                          if (response.ok)
                            setData(response.data);

                          setIsLoaded(true);
                        });
                    }}
                  >
                    Genereaza
                  </Button>
                }
              >
                <ExcelSheet
                  data={data.services.filter(service => !!~checked.indexOf(service.id)).map((service, i) => ({...service, nrCrt: i + 1}))}
                  name={`Borderou COVID-19 ${(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60 * 1000))).toISOString().split('T')[0]}`}
                >
                  <ExcelColumn label='Nr. crt.' value='nrCrt' />
                  <ExcelColumn label='Nume pacient' value='person' />
                  <ExcelColumn label='Prenume pacient' value={() => ''} />
                  <ExcelColumn label='CNP' value='cnp' />
                  <ExcelColumn label='Data nasterii' value='birthDate' />
                  <ExcelColumn label='Varsta' value='ageYears' />
                  <ExcelColumn label='Sex' value='sex' />
                  <ExcelColumn label='Judet' value='county' />
                  <ExcelColumn label='Localitate' value='city' />
                  <ExcelColumn label='Adresa completa' value='address' />
                  <ExcelColumn label='Telefon' value='phone' />
                  <ExcelColumn label='Email' value='email' />
                  <ExcelColumn label='ID proba' value='idReceptionSL' />
                  <ExcelColumn label='AI/BI/CI/Pasaport' value={() => ''} />
                  <ExcelColumn label='Serie carte de identitate' value={() => ''} />
                  <ExcelColumn label='Numar act de identitate' value={() => ''} />
                  <ExcelColumn label='Tip cerere' value={() => 'La cerere'} />
                  <ExcelColumn label='Tip pacient' value={() => 'Altele'} />
                  <ExcelColumn label='Tip proba' value={() => 'Exsudat nazo-orofaringian'} />
                  <ExcelColumn label='COVID (0/1)' value={() => '1'} />
                  <ExcelColumn label='GRIPA (0/1)' value={() => '0'} />
                  <ExcelColumn label='Recoltat la' value='dateOfSample' />
                  <ExcelColumn label='Este urgenta (0/1)' value={() => '0'} />
                  <ExcelColumn label='Observatii' value='memo' />
                  <ExcelColumn label='Test rapid (0/1)' value={() => '0'} />
                </ExcelSheet>
              </ExcelFile>
            }
            {!Boolean(~['64', '70'].indexOf(filter.idCompany)) &&
              <Button fullWidth variant='contained' color='primary' size='large'
                disabled={!Boolean(checked.length)}
                onClick={() => {
                  window.open(`${props.url.download}?op=externLabsOrder&idCompany=${filter.idCompany}&method=${filter.method}&idReceptionServicesSL=${checked.join(',')}&SID=${props.user.sessid}&variant=live`);
                  setIsLoaded(false);
                  ajax('externLabsUnsentServices', {
                    idReceptionServicesSL: checked
                  })
                    .then(response => {
                      if (!isMountedRef.current) return;

                      if (response.ok)
                        setData(response.data);

                      setIsLoaded(true);
                    });
                }}
              >
                Genereaza
              </Button>
            }
          </Grid>
        </Grid>
      }

      {isLoaded && data.lastSent.filter(item => item.idCompany === filter.idCompany && item.method === filter.method).length > 0 &&
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <Typography>
              Ultimul borderou a fost generat la data de {data.lastSent.filter(item => item.idCompany === filter.idCompany && item.method === filter.method)[0].createdAt}
            </Typography>
          </CardContent>
          <CardActions>
            <Button color='secondary' style={{marginLeft: 'auto'}}
                onClick={() => {
                  setIsLoaded(false);
                  ajax('externLabsUndoLastSent', {
                    createdAt: data.lastSent.filter(item => item.idCompany === filter.idCompany && item.method === filter.method)[0].createdAt
                  })
                    .then(response => {
                      if (!isMountedRef.current) return;

                      if (response.ok)
                        setData(response.data);

                      setIsLoaded(true);
                    });
                }}
              >
                Anuleaza-l
              </Button>
          </CardActions>
        </Card>
      }

      {isLoaded && data.services.length > 0 && data.services.filter(filterData).length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda filtrelor aplicate.</Warning>
      }

      {isLoaded &&
        <List dense>
          {data.services.filter(filterData).map((item, i, a) =>
            <Fragment key={item.id}>
              {(i === 0 || a[i].dateOfSample.split(' ')[0] !== a[i - 1].dateOfSample.split(' ')[0]) &&
                <ListSubheader disableSticky>{`Probe recoltate in data de ${item.dateOfSample.split(' ')[0]}: ${a.filter(service => service.dateOfSample.split(' ')[0] === item.dateOfSample.split(' ')[0]).length}`}</ListSubheader>
              }

              <ListItem dense className={classes.listItemDense}
                button={!Boolean(~['64', '70'].indexOf(item.idCompany)) || (Boolean(~['64', '70'].indexOf(item.idCompany)) && Boolean(item.phone) && Boolean(item.county) && Boolean(item.city) && Boolean(item.address))}
                onClick={handleToggle(item)}
              >
                <ListItemIcon>
                  {Boolean(~['64', '70'].indexOf(item.idCompany)) && (!Boolean(item.phone) || !Boolean(item.county) || !Boolean(item.city) || !Boolean(item.address))
                    ? <ErrorOutlineIcon color='secondary' />
                    : <Checkbox size='medium' color='primary' edge='start' tabIndex={-1} disableRipple
                        checked={checked.indexOf(item.id) !== -1}
                      />
                  }
                </ListItemIcon>
                <ListItemText className={classes.listItemTextDense} disableTypography
                  primary={
                    <Typography display='block' style={{fontWeight: 'bold'}}>
                      {item.person}
                      <Typography component='span' display='inline' color='textSecondary'> (CNP: {item.cnp})</Typography>
                    </Typography>
                  }
                  secondary={
                    <Box>
                      <Typography display='block'>
                        {item.service}
                        <Typography component='span' display='inline' color='textSecondary'> [ID SL: {item.idReceptionSL}]</Typography>
                      </Typography>
                      {Boolean(~['64', '70'].indexOf(item.idCompany)) &&
                        <Box>
                          <Typography component='span' display='block' color={Boolean(item.phone) ? 'textSecondary' : 'secondary'}>
                            <EditableField editIcon={null}
                              label='Telefon:'
                              value={item.phone}
                              onChange={handleDataUpdate}
                              ajax={ajax}
                              ajaxOp='slPersonSavePhone'
                              ajaxParamName='phone'
                              ajaxUniqueKeyName='idPerson'
                              ajaxUniqueKeyValue={item.idPerson}
                            />
                          </Typography>
                          <Typography component='span' display='inline' color={Boolean(item.county) ? 'textSecondary' : 'secondary'}>
                            <EditableField editIcon={null}
                              type='select'
                              options={data.counties}
                              label='Judet:'
                              value={item.county}
                              onChange={handleDataUpdate}
                              ajax={ajax}
                              ajaxOp='slPersonSaveCounty'
                              ajaxParamName='county'
                              ajaxUniqueKeyName='idPerson'
                              ajaxUniqueKeyValue={item.idPerson}
                            />
                          </Typography>
                          <Typography component='span' display='inline' color={Boolean(item.city) ? 'textSecondary' : 'secondary'}>
                            <EditableField editIcon={null}
                              label='Localitate:'
                              value={item.city}
                              onChange={handleDataUpdate}
                              ajax={ajax}
                              ajaxOp='slPersonSaveCity'
                              ajaxParamName='city'
                              ajaxUniqueKeyName='idPerson'
                              ajaxUniqueKeyValue={item.idPerson}
                            />
                          </Typography>
                          <Typography component='span' display='inline' color={Boolean(item.address) ? 'textSecondary' : 'secondary'}>
                            <EditableField editIcon={null}
                              label='Adresa:'
                              value={item.address}
                              onChange={handleDataUpdate}
                              ajax={ajax}
                              ajaxOp='slPersonSaveAddress'
                              ajaxParamName='address'
                              ajaxUniqueKeyName='idPerson'
                              ajaxUniqueKeyValue={item.idPerson}
                            />
                          </Typography>
                          {/* <Typography component='span' display='block' color={Boolean(item.county) ? 'textSecondary' : 'secondary'}>
                            <EditableField editIcon={null}
                              type='select'
                              options={[
                                {id: '', value: 'Nu este cazul'},
                                {id: 'Medic', value: 'Medic'},
                                {id: 'Asistent', value: 'Asistent'},
                                {id: 'Ambulantier', value: 'Ambulantier'},
                                {id: 'Infirmier', value: 'Infirmier'},
                                {id: 'Altele', value: 'Altele'}
                              ]}
                              label='Personal medico-sanitar:'
                              value={item.resultComment}
                              onChange={handleDataUpdate}
                              ajax={ajax}
                              ajaxOp='slReceptionServiceSaveResultComment'
                              ajaxParamName='resultComment'
                              ajaxUniqueKeyName='idReceptionService'
                              ajaxUniqueKeyValue={item.id}
                            />
                          </Typography> */}
                        </Box>
                      }
                      <Typography variant='caption' color='primary' style={{fontStyle: 'italic'}}>{item.memo}</Typography>
                    </Box>
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton edge='end'
                    onClick={() => setDeleteIdService(item.id)}
                  >
                    <DeleteIcon color='secondary' />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            </Fragment>
          )}
        </List>
      }

      {deleteIdService &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          open={Boolean(parseInt(deleteIdService))}
          TransitionComponent={Transition}
          onClose={() => setDeleteIdService(null)}
        >
          <DialogTitle>Marcati aceste probe ca sterse?</DialogTitle>
          <DialogContent>
            <DialogContentText><Typography component='span'>Apasati pe STERGE doar daca sunteti sigur ca doriti sa stergeti acest serviciu. Dupa stergere nu veti mai avea acces la acesta.</Typography></DialogContentText>
            <DialogContentText><Typography component='span'>Aceasta operatiune nu va modifica nimic in receptia deschisa in SmartLabs.</Typography></DialogContentText>
            <DialogContentText><Warning component='span'>Atentie, dupa confirmare, filtrele alese de d-voastra (laborator si metoda de transport) se vor reseta la cele implicite!.</Warning></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={() => setDeleteIdService(null)}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='secondary' onClick={externLabsMarkServiceAsDeleted}>
              Sterge
            </Button>
          </DialogActions>
        </Dialog>
      }
    </Container>
  );
}